import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    dialog: {
      width: 900,
      maxWidth: 900,
      borderRadius: 16,
      padding: '16px 32px 32px 32px',

      '@media (max-width: 1180px)': {
        width: 343,
      },
    },
    dialogAction: {
      marginTop: 20,
      flexDirection: 'column',
      paddingLeft: 0,
      paddingRight: 0,
      alignItems: 'flex-start',
    },
    btn: {
      padding: 16,
    },
    inputField: {
      width: '100%',
      height: 56,
      borderRadius: 8,
      backgroundColor: variables.greyLight,
      border: 0,
      textAlign: 'start',

      '& .MuiInputBase-root': {
        color: variables.richBlack,
      },

      '& fieldset': {
        border: 'none',
      },

      '&.Mui-focused, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: '1px solid black',
        borderRadius: 8,
      },
    },

    hidden: {
      display: 'none',
    },
    formControl: {
      width: '100%',
      marginTop: 3,
      minWidth: 175,
      maxWidth: 673,
      marginBottom: 10,
      '&:hover, & .Mui-focused, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: variables.davyGrey,
        borderWidth: 1,
      },
      '& .MuiOutlinedInput-root': {
        borderRadius: 10,
      },
    },
    modalWindow: {
      maxWidth: 675,
    },
    closeBtn: {
      paddingTop: 6,
      paddingBottom: 6,
      width: 122,
      borderRadius: 50,
      borderColor: variables.fossilGrey,
    },
    dialogWidth: {
      width: 650,
    },
    container: {
      marginTop: 10,
    },
    selectField: {
      borderColor: variables.abalonGrey,
      borderRadius: 10,
      '&:hover, &.Mui-focused': {
        borderColor: variables.davyGrey,
      },
      '&&&:before': {
        borderBottom: 'none',
      },
      '&&:after': {
        borderBottom: 'none',
      },
    },
    selectIconClass: {
      color: variables.cadetBlue,
    },
    partnershipSelect: {
      width: '100%',
      paddingBottom: 8,
      paddingTop: 8,
      backgroundColor: 'transparent',
      borderRadius: 10,
      overflow: 'hidden',
    },
    tabContainer: {
      width: '100%',
      padding: '18px 0 0 0',
    },
    fieldContainer: {
      paddingTop: 10,
      paddingBottom: 10,
      '& legend': {
        width: 0,
        display: 'none',
      },
    },
    shortcodeContainer: {
      paddingTop: 8,
      paddingBottom: 10,
    },
    input: {
      width: 17,
      height: 15,
      color: variables.fossilGrey,
    },
    rightContainer: {
      float: 'right',
    },
    realDemoButton: {
      backgroundColor: variables.black10,
      borderRadius: 8,
      height: 56,
      padding: 3,
    },
    linkType: {
      width: '100%',
      borderRadius: 8,
      height: 48,
      color: variables.richBlack,

      '&:hover': {
        backgroundColor: variables.white,
        color: variables.black50,
      },
    },
    linkTypeSelected: {
      backgroundColor: variables.white,
    },

    fieldContainerLeft: {
      paddingTop: 10,
      paddingBottom: 10,
      '& legend': {
        width: 0,
        display: 'none',
      },
    },
    fieldContainerRight: {
      paddingTop: 10,
      paddingBottom: 10,
      '& legend': {
        width: 0,
        display: 'none',
      },
    },
    mobileView: {
      '@media (max-width: 540px)': {
        maxWidth: '100%',
        flexBasis: '100%',
      },
    },
    autoComplete: {
      '& .MuiAutocomplete-popupIndicatorOpen': {
        transform: 'none',
      },
    },
    autocompleteField: {
      margin: 0,
      '& .MuiAutocomplete-inputRoot': {
        color: variables.richBlack,
        border: 0,
        height: 56,
        padding: 16,
        borderRadius: 8,
        backgroundColor: variables.greyLight,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        top: 0,
        border: 'none',
      },
    },
  }),
);
